export enum PlasticProductGridType {
  OVERVIEW,
  INLINE
}
